import { downloadRepaymentSchedule } from '@api/lendingAPI/LendingAPI';
import { IconDownload } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { useMutation } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import styles from './RepaymentScheduleModal.module.css';
import { RepaymentScheduleTable } from './RepaymentScheduleTable';
import { useStateKey } from '../../../iwQueryClient/useStateKey';

const mapStateToProps = (state: RootState) => {
    return {
        repaymentScheduleModal: state.repaymentScheduleModal
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

export const RepaymentScheduleModalContent = (props: PropsFromRedux) => {
    const { repaymentScheduleModal } = props;
    const stateKey = useStateKey();

    const { mutate: downloadSchedule, isLoading: isDownloading } = useMutation({
        mutationKey: [
            'downloadRepaymentSchedule',
            stateKey,
            repaymentScheduleModal.accountId
        ],
        mutationFn: () =>
            downloadRepaymentSchedule({
                impersonatingStateKey: stateKey,
                accountId: repaymentScheduleModal.accountId
            })
    });
    return (
        <div
            data-testid="repayments-schedule-modal-deprecated"
            className={styles.RepaymentScheduleModal}
        >
            <div className="flex flex-row items-baseline justify-between align-middle">
                <div className={styles.title}>
                    <FormattedMessage
                        id="_.modal.repayment_schedule.title"
                        defaultMessage="Repayment schedule"
                    />
                </div>
                {Boolean(repaymentScheduleModal.accountId) && (
                    <Button
                        onClick={() => downloadSchedule()}
                        loading={isDownloading}
                        variant="secondary-alt"
                    >
                        <FormattedMessage
                            id="_.modal.repayment_schedule.download_button"
                            defaultMessage="Download"
                        />
                        <IconDownload />
                    </Button>
                )}
            </div>
            <RepaymentScheduleTable {...repaymentScheduleModal} />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RepaymentScheduleModalContent);
